<!--
@name 工商管理博士-DBA
-->
<template>
  <div class="cont-page">
    <!-- 公共导航 -->
    <home-header></home-header>
    <!-- banner -->
    <div class="banner-info"></div>
    <!-- banner -->
    <!-- 内容 -->
    <div class="content">
      <!--  专业介绍 -->
      <div class="cont-item">
        <div class="title-image">项目简介</div>
        <div class="selector-indent">
          法国布雷斯特高等商学院工商管理博士项目(Doctor of Bussiness
          Administration,简称DBA)项目，旨在整合全球政、商、学等各界资源，为企业家打造国际化学习交流与合作平台。该项目汇聚北京大学、清华大学、中科院等国内知名高校、权威智库与商学院专家学者、优秀企业家导师，致力于培养适应A时代变革和“新商科”发展要求的新时代思想型企业家。
        </div>
      </div>
      <!--  专业介绍 -->
      <!--  项目优势 -->
      <div class="cont-item">
        <div class="title-image">项目优势</div>
        <div class="advantage">
          <p class="advantage-title">学位全球认可</p>
          <p>学位受法国高等教育部权威认证，全球认可。商学院得到中国国家教育部“教育涉外监管网”公布认可。</p>
          <p class="advantage-title">名师大家云集</p>
          <p>
            云集国内外政要和名师大家，研讨国际前沿新知，把握世界发展格局，了解经济新政策、产业新趋势，树立全球视野，解决发展难题。</p>
          <p class="advantage-title">国际国内研学</p>
          <p>深入参访中国和欧洲重点城市和世界知名企业，通过案例研讨，借鉴学习世界标杆企业的领先之道。</p>
          <p class="advantage-title">双导师辅导制</p>
          <p>
            建立知名教授和知名企业家双导师辅导制，近距离汲取知名教授和企业家管理新知，做到理论和实践融会贯通、知行合一。</p>
          <p class="advantage-title">资源平台对接</p>
          <p>
            组织投融资洽谈和项目路演，搭建中欧“政·产·学·研·金”资源对接与合作共赢平台，推进全国和全球产业布局，助力企业发展壮大。</p>
        </div>
      </div>
      <!-- 项目优势 -->
      <!-- 培养方式 -->
      <div class="cont-item">
        <div class="title-image">培养特色</div>
        <div>
          <img src="@/assets/images/personRain/dba01.png" alt="" class="course-img"/>
        </div>
      </div>
      <!-- 培养方式 -->
      <!-- 课程简介 -->
      <div class="cont-item">
        <div class="title-image">课程设计</div>
        <p>15门核心课程/五位一体</p>
        <img src="@/assets/images/personRain/dba-course01.png" alt="" class="course-img"/>
        <img src="@/assets/images/personRain/dba-course02.png" alt="" class="course-img"/>
        <img src="@/assets/images/personRain/dba-course03.png" alt="" class="course-img"/>
      </div>
      <!-- 课程简介 -->
      <!-- 部分师资 -->
      <div class="cont-item">
        <div class="title-image">师资阵容</div>
        <p>
          邬贺铨：中国工程院院士、原副院长/国家战略性新兴产业发展专家咨询委员会副主任/国家下一代互联网示范工程专家委主任。</p>
        <p>刘伟：中国人民大学原校长/北京大学原常务副校长著名经济学家。</p>
        <p>张燕生：中国国际交流中心首席研究员/国家发改委学术委员会委员/中央政治局集体学习授课人。</p>
        <p>陈东敏：北京大学前沿交叉学科研究院特聘教授/广东松山湖材料实验室常务副主任/美国硅谷连环创业者。</p>
        <p>杨禹：中国发展改革报社副社长/中央广播电视总台特约评论员。</p>
        <p>郁俊莉：北京大学政府管理学院教授、博导/北京大学中国新兴产业创新研究中心主任广东省发改委学术委员会委员。</p>
        <p>程郁缀：北京大学中文系教授、博导/CCTV《百家讲坛》主讲专家/北京大学亚太研究院副院长家。</p>
        <p>周旺生：北京大学法学院教授、博导/北京大学立法学研究中心主任/著名立法学专家。</p>
        <p>
          姜正新：北京大学中国新兴产业创新研究中心专家委员会副主任/华中师范大学特聘教授/曾任中国联通集团高级副总裁/国家大数据专家委员会专家。</p>
        <!--        <p>Mériadec Le Mouillour：海事功勋骑士勋章获得者/前西布列塔尼工商会总经理/法国港口联盟副主席、高级海事委员会成员和欧洲海港组织执行委员会成员。</p>-->
        <!--        <p>Slim HADOUSSA：布雷斯特高等商学院教研主任、副教授/图卢兹第一大学企业管理学院博士。</p>-->
        <p>Bertrand PAUGET：教授；管理学方向；现任教务长兼研究院院长。</p>
        <p>Dominique MAZÉ：副教授；国际战略与跨文化管理方向；EMBA项目主管。</p>
        <p>Houssem CHEMINGUI：副教授，信息系统与数据工程方向。</p>
        <p>Mériadec Le
          Mouillour：海事功勋骑士勋章获得者，前西布列塔尼工商会总经理，法国港口联盟副主席、高级海事委员会成员和欧洲海港组织执行委员会成员。</p>
        <p>魏炜：北京大学汇丰商学院管理学教授、博导/商业模式研究中心主任/中国商业模式理论创始人长。</p>
        <p>曹仰锋：北京大学光华管理学院管理实践教授/香港创业创新研究院院长/美国硅谷知名创业孵化器Plug and
          Play中国创新生态研究院院长。</p>
        <p>吕守升：中外企业人力资源协会（HRA)会长/高潜咨询公司创始合伙人/国家科技部专家库成员/战略解码学派开创者。</p>
        <p>冯科：北京大学经济学院教授、博导/北京大学金融与产业发展研究中心主任/国家互联网金融安全技术专家委员会委员。</p>
        <p>王超：北京大学国家发展研究院教授/清华大学公益慈善研究院资深研究员/北京大学城市规划与设计学院兼职教授。</p>
        <p>王岳川：北京大学中文系教授博导/北京大学书法艺术研究所所长/CCTV《百家讲坛》主讲专家。</p>
        <p>吕本富：中国科学院大学教授、博导/国家创新与发展战略研究会副会长/著名数字经济专家。</p>
        <p>薛旭：北京大学经济学院教授/企业战略管理课程的首创者/著名战略管理与营销管理专家。</p>
        <p>余顺坤：华北电力大学经济与管理学院教授、博士生导师/现代人事技术研究所所长/中国人事科学研究院研究员。</p>
        <p>张延：北京大学经济学院教授、博导/北京大学精品课程主讲人。</p>
        <p>周宏桥：北京大学国家发展研究院特聘教授/“半面创新”思想体系创构者/极客/诗家/学者/跨界创新者。</p>
        <p>江英：军事科学院研究员、 博导/中央政治局集体学习授课专家/CCTV《百家讲坛》主讲专家。</p>
        <p>路长全：切割营销理论创始人/北京赞伯营销管理咨询有限公司董事长/国内多所重点高校客座教授/著名品牌营销专家。</p>
      </div>
      <!-- 部分师资 -->
      <!-- 学习安排 -->
      <div class="cont-item">
        <div class="advantage">
          <div class="title-image">学习安排</div>
          <p class="advantage-title">项目学制</p>
          <p>
            3年在职学习，前1.5年以面授课程、实践研学为主；后1.5年以学术研究、论文写作为主。修满全部课程60学分，申请参加论文答辩。答辩通过后，获颁工商管理博士学位。
          </p>
          <p class="advantage-title">上课形式</p>
          <p>每月集中2~3天，包含实践研学1天，课堂面授2天（辅以案例分析、小组研讨交流等沉浸式学习方式)。</p>
          <p class="advantage-title">上课地点</p>
          <p>北京为教学总部，国内重点城市移动课堂。</p>
        </div>
      </div>
      <!-- 学习安排 -->
      <!-- 入学流程 -->
      <div class="cont-item">
        <!--申请条件-->
        <div class="title-image">申请条件</div>
        <p>
          具有硕士学位或研究生毕业证书或研究生同等学历结业证书，学科专业不限；同时具有十年以上工作经验和五年以上管理经验的行业龙头企事业董事长、总经理或高级管理者。</p>
        <!--申请条件-->
        <!--申请材料-->
        <div class="title-image">申请材料</div>
        <div class="apply-item">
          <p class="apply-text">1.申请表（中英文）各一份</p>
          <p class="apply-text">2.个人履历（中英文）各一份</p>
          <p class="apply-text">3.最高学历证书原件或复印件及英文翻译件</p>
          <p class="apply-text">4.认证过的毕业证复印件或学信网认证报告</p>
          <p class="apply-text">5.身份证复印件及英文翻译件</p>
          <p class="apply-text">6.白底两寸照片4张和电子版</p>
          <p class="apply-text">7.名片4张</p>
          <p class="apply-text">8.中文推荐信1封</p>
          <p class="apply-text">9.就职公司简介（中文即可)一份</p>
        </div>
        <!--申请材料-->
        <!-- 培养方式 -->
        <div class="cont-item">
          <div class="title-image">录取机制</div>
          <p>实行“面试+推荐”双模式入学制。综合考量申请者的基本素质、教育背景、工作经验、研习能力、战略远见等，择优录取。</p>
        </div>
        <!-- 培养方式 -->
        <!-- 学费标准 -->
        <div class="cont-item">
          <div class="title-image">学费标准</div>
          <p>含注册费、授课费、教学管理费、学位证书费等费用。</p>
          <p>上课期间交通、食宿及国内外参访游学等费用自理。</p>
        </div>
        <!-- 学费标准 -->
      </div>
      <!-- 入学流程 -->
      <!-- 相关资料下载 -->
      <!--      <div class="down-load">-->
      <!--        <p>相关资料下载</p>-->
      <!--        <p class="open-pdf" @click="openPdf">工商管理博士</p>-->
      <!--      </div>-->
      <!--      <div style="clear: both" />-->
      <!-- 相关资料下载 -->
    </div>
    <!-- 内容 -->
    <!-- 公共版权 -->
    <home-footer></home-footer>
    <!-- 公共版权 -->

  </div>
</template>

<script>
import HomeHeader from "@/components/homeHeader";
import HomeFooter from "@/components/homeFooter";

export default {
  name: 'MbaVue',
  components: {
    HomeHeader,
    HomeFooter
  },
  data() {
    return {};
  },
  methods: {
    // openPdf() {
    //   window.open('http://cdn.yzvet.com/group1/M00/3F/9F/wKgCEmfIGiiAXyKiASO3kxRhutQ778.pdf', '_blank');
    // }
  }
};
</script>

<style scoped lang="less">
.cont-page {
  background: #fff;
  height: auto;

  .banner-info {
    width: 100%;
    height: 200px;
    background: url(../assets/images/banner002.png);
    background-size: 100% 100%;
  }

  .content {
    width: 95%;
    margin: 0 auto;
    padding-bottom: 80px;

    .cont-item {
      .title-image {
        background: url("../assets/images/pic1.png") no-repeat;
        width: 200px;
        height: 56px;
        line-height: 56px;
        background-size: 100% 100%;
        font-size: 24px;
        font-weight: 700;
        padding-left: 60px;
        color: #323232;
        margin: 40px 0;
      }

      p {
        font-size: 24px;
        color: #333;
        line-height: 38px;
      }

      .selector-indent {
        text-indent: 40px;
        font-size: 24px;
        font-weight: 400;
        color: #333;
        line-height: 38px;
      }

      //项目优势
      .advantage {
        .advantage-title {
          font-weight: bold;

          &:before {
            content: '';
            display: inline-block;
            vertical-align: middle;
            width: 20px;
            height: 20px;
            background: #e58111;
            border-radius: 10%;
            margin-right: 8px;
          }
        }

        p {
          font-size: 24px;
          color: #333;
          vertical-align: middle;
        }
      }

      // 图片
      .course-img {
        max-width: 100%;
      }

      // 入学流程
      .flow-img {
        width: 100%;
      }

      // 申请资料
      .apply-item {
        background: #e58111;
        border-radius: 5px;
        margin-top: 20px;
        padding: 20px;

        .apply-text {
          color: #fff;
          font-size: 24px;
          line-height: 50px;
        }
      }
    }

    // 相关资料下载
    .down-load {
      float: right;
      font-size: 24px;
      margin-top: 50px;
      color: #333;
      text-align: right;

      .open-pdf {
        margin-top: 10px;
        font-size: 24px;
        color: #e58111;
        cursor: pointer;
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/pages/eduDba.vue